import api from './api';

/**
 * Get unique keyword suggestions from the user's (or catalog owner's) catalog items.
 *
 * When ownerId is provided, the backend will verify the active delegation and
 * return the catalog owner's keyword suggestions instead of the caller's own (fixes #952).
 */
export const getKeywordSuggestions = async (ownerId?: string): Promise<string[]> => {
  const params: Record<string, string> = {};
  if (ownerId) {
    params.owner_id = ownerId;
  }
  const response = await api.get('/api/keywords/suggestions', { params });
  return response.data;
};
